// import Lottie from "lottie-web";
import Lottie from 'lottie-web/build/player/lottie_light';

// Store all Lottie animation instances
const lottieInstances = [];

// Initialize Lottie animation for a single element
function initializeLottie(element) {
    const dataSrc = element.getAttribute('data-src');
    if (!dataSrc) return null;

    const animation = Lottie.loadAnimation({
        container: element,
        renderer: 'svg',
        loop: true,
        autoplay: true,
        path: dataSrc
    });

    lottieInstances.push(animation);
    return animation;
}

// Check for reduced motion preference
const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

// Insert early in the DOM so it is one of the first tab stops.
// Visual position stays bottom-right via position: fixed CSS.
function insertLottieControlButton(button) {
    const skipLink = document.querySelector('.skip-link');
    if (skipLink) {
        skipLink.after(button);
        return;
    }

    if (document.body.firstElementChild) {
        document.body.insertBefore(button, document.body.firstElementChild);
    } else {
        document.body.appendChild(button);
    }
}

// Create pause/play button
function createLottieControlButton() {
    // Only create button if there are animations
    if (lottieInstances.length === 0) return;

    // Don't create if button already exists
    if (document.querySelector('.lottie-pause-button')) return;

    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'lottie-pause-button';
    button.setAttribute('aria-label', 'Pause animations');
    button.setAttribute('title', 'Pause animations');
    button.innerHTML = '<span class="pause-icon">⏸</span><span class="play-icon" style="display: none;">▶</span>';

    let isPaused = false;

    button.addEventListener('click', function() {
        isPaused = !isPaused;

        if (isPaused) {
            // Pause all animations
            lottieInstances.forEach(instance => {
                instance.pause();
            });
            button.setAttribute('aria-label', 'Play animations');
            button.setAttribute('title', 'Play animations');
            button.querySelector('.pause-icon').style.display = 'none';
            button.querySelector('.play-icon').style.display = 'inline';
            button.classList.add('is-paused');
        } else {
            // Play all animations
            lottieInstances.forEach(instance => {
                instance.play();
            });
            button.setAttribute('aria-label', 'Pause animations');
            button.setAttribute('title', 'Pause animations');
            button.querySelector('.pause-icon').style.display = 'inline';
            button.querySelector('.play-icon').style.display = 'none';
            button.classList.remove('is-paused');
        }
    });

    // Add button to page when body is available
    if (document.body) {
        insertLottieControlButton(button);
    } else {
        // Wait for body if not available yet
        document.addEventListener('DOMContentLoaded', function() {
            if (document.body && !document.querySelector('.lottie-pause-button')) {
                insertLottieControlButton(button);
            }
        });
    }
}

// Initialize all Lottie animations
if (document.querySelector('.lemonly .lottie-animation') && !prefersReducedMotion) {
    const elements = document.querySelectorAll('.lemonly .lottie-animation');
    elements.forEach(function (element) {
        // Only initialize if it has a data-src attribute (JSON Lottie file)
        if (element.getAttribute('data-src')) {
            initializeLottie(element);
        }
    });

    // Create button after initializing animations
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', createLottieControlButton);
    } else {
        createLottieControlButton();
    }
}

// Handle reduced motion preference
if (prefersReducedMotion) {
    document.querySelectorAll('.lottie-animation').forEach(element => {
        element.style.display = 'none';
    });
}